<template>
  <div style="margin-top: 40px">
    <div style="margin-bottom: 10px;">
      <h2>
        Suche nach weiteren Kriterien
      </h2>
      <span>
        Die Kriterien können mit jeder Auswahl von Sprachen und Schriften kombiniert werden. Die Suche mit ODER beeinflusst diese Kriterien und kann zu Suchergebnissen führen, die die von dir ausgewählten Sprachen nicht enthalten.
      </span>
    </div>

    <div class="criteria-facets">
      <Criterion
        v-for="criterion in criteria"
        :key="criterion.title"
        :criterion="criterion"
      />
    </div>
  </div>
</template>

<script>
import Criterion from './Criterion';
export default {
    name: 'Criteria',
    components: { Criterion },
    data () {
        return {
            criteria: [
                {
                    title: 'Schildtyp',
                    type: 'type',
                    facets: [
                        { name: 'Aufkleber', value: 'SI004', active: false },
                        { name: 'Bedrucktes Schild', value: 'SI001', active: false },
                        { name: 'Digitales Schild', value: 'SI007', active: false },
                        { name: 'Flyer', value: 'SI003', active: false },
                        { name: 'Graffiti', value: 'SI008', active: false },
                        { name: 'Handnotiz / Aushang', value: 'SI005', active: false },
                        { name: 'Inschrift', value: 'SI006', active: false },
                        { name: 'Poster', value: 'SI002', active: false },
                    ]
                },
                {
                    title: 'Geschäftstyp',
                    type: 'outlet',
                    facets: [
                        { name: 'Bäckerei', value: 'OU005', active: false },
                        { name: 'Café / Kneipe', value: 'OU007', active: false },
                        { name: 'Imbiss / Take away', value: 'OU003', active: false },
                        { name: 'Lebensmittelladen', value: 'OU004', active: false },
                        { name: 'Restaurant', value: 'OU002', active: false },
                        { name: 'Supermarkt', value: 'OU006', active: false },
                        { name: 'Wohnhaus', value: 'OU001', active: false },
                        { name: 'Amtsgebäude', value: 'OU031', active: false },
                        { name: 'Anwaltskanzlei', value: 'OU024', active: false },
                        { name: 'Apotheke', value: 'OU023', active: false },
                        { name: 'Arztpraxis', value: 'OU026', active: false },
                        { name: 'Bahnhof / Haltestelle', value: 'OU035', active: false },
                        { name: 'Bankfiliale', value: 'OU029', active: false },
                        { name: 'Baumarkt', value: 'OU017', active: false },
                        { name: 'Bibliothek', value: 'OU042', active: false },
                        { name: 'Steuerberater', value: 'OU025', active: false },
                        { name: 'Buchhaltung', value: 'OU018', active: false },
                        { name: 'Elektronik', value: 'OU019', active: false },
                        { name: 'Fitnesscenter', value: 'OU043', active: false },
                        { name: 'Flughafen / Hafen', value: 'OU037', active: false },
                        { name: 'Friseur / Kosmetik', value: 'OU010', active: false },
                        { name: 'Geldautomat', value: 'OU045', active: false },
                        { name: 'Gemeinschafts- / Kulturzentrum', value: 'OU008', active: false },
                        { name: 'Immobilienmarkler', value: 'OU022', active: false },
                        { name: 'Juwelier', value: 'OU011', active: false },
                        { name: 'Kita', value: 'OU040', active: false },
                        { name: 'Kleidung', value: 'OU014', active: false },
                        { name: 'Krankenhaus', value: 'OU038', active: false },
                        { name: 'Museum', value: 'OU041', active: false },
                        { name: 'Öffentliche Verkehrsmittel', value: 'OU036', active: false },
                        { name: 'Parkuhr', value: 'OU046', active: false },
                        { name: 'Plakatwand', value: 'OU047', active: false },
                        { name: 'Postfiliale', value: 'OU030', active: false },
                        { name: 'Reisebüro', value: 'OU020', active: false },
                        { name: 'Religiöse Einrichtung', value: 'OU009', active: false },
                        { name: 'Schneider', value: 'OU013', active: false },
                        { name: 'Schreibwaren', value: 'OU015', active: false },
                        { name: 'Schule', value: 'OU039', active: false },
                        { name: 'Souvenir', value: 'OU012', active: false },
                        { name: 'Straßenschild', value: 'OU033', active: false },
                        { name: 'Tankstelle', value: 'OU028', active: false },
                        { name: 'Universität', value: 'OU044', active: false },
                        { name: 'Verkehrsschild', value: 'OU034', active: false },
                        { name: 'Waschsalon', value: 'OU016', active: false },
                        { name: 'Wechselstube', value: 'OU021', active: false },
                        { name: 'Werkstatt', value: 'OU027', active: false },
                        { name: 'Sonstige', value: 'OUOTHER', active: false },
                    ]
                },
                {
                    title: 'Position',
                    type: 'position',
                    facets: [
                        { name: 'Briefkasten', value: 'PO007', active: false },
                        { name: 'Gebäude außen', value: 'PO001', active: false },
                        { name: 'Gebäude innen', value: 'PO002', active: false },
                        { name: 'Marktstand', value: 'PO003', active: false },
                        { name: 'Plakat / Plakatwand / Kundenstopper', value: 'PO004', active: false },
                        { name: 'Türklingel', value: 'PO008', active: false },
                        { name: 'Verkehrsmittel außen', value: 'PO005', active: false },
                        { name: 'Verkehrsmittel innen', value: 'PO006', active: false },
                        { name: 'Sonstige', value: 'PO009', active: false },
                    ]
                },
                {
                    title: 'Design',
                    type: 'design',
                    facets: [
                        { name: 'Begleitbild', value: 'DE003', active: false },
                        { name: 'Bild vom Produkt', value: 'DE002', active: false },
                        { name: 'Logo', value: 'DE001', active: false },
                    ]
                },
                {
                    title: 'Inhalt',
                    type: 'content',
                    facets: [
                        { name: 'Geschäfts- / Einrichtungs- / Personenname', value: 'CO001', active: false },
                        { name: 'Information über Dienstleistung', value: 'CO007', active: false },
                        { name: 'Information über Geschäft', value: 'CO003', active: false },
                        { name: 'Information über Produkt', value: 'CO006', active: false },
                        { name: 'Name einer Dienstleistung', value: 'CO005', active: false },
                        { name: 'Name eines Produktes', value: 'CO004', active: false },
                        { name: 'Orts- / Straßenname', value: 'CO002', active: false },
                        { name: 'Persönliche Nachricht', value: 'CO011', active: false },
                        { name: 'Politische / religiöse Botschaft', value: 'CO010', active: false },
                        { name: 'Sicherheitshinweis', value: 'CO008', active: false },
                        { name: 'Veranstaltungsinfo', value: 'CO009', active: false },
                        { name: 'Sonstige', value: 'CO012', active: false },
                    ]
                },
                {
                    title: 'Domäne',
                    type: 'sector',
                    facets: [
                        { name: 'Offiziell', value: 'SE001', active: false },
                        { name: 'Privat', value: 'SE002', active: false },
                        { name: 'Transgressiv', value: 'SE003', active: false },
                    ]
                },
                {
                    title: 'Publikum',
                    type: 'audience',
                    facets: [
                        { name: 'Exklusiv', value: 'AU001', active: false },
                        { name: 'Inklusiv', value: 'AU002', active: false },
                    ]
                },
                {
                    title: 'Kommunikativer Zweck',
                    type: 'purpose',
                    facets: [
                        { name: 'Emblematisch', value: 'PU002', active: false },
                        { name: 'Kommunikativ', value: 'PU001', active: false },
                    ]
                },
                {
                    title: 'Funktion',
                    type: 'method',
                    facets: [
                        { name: 'Anwerbung', value: 'FU002', active: false },
                        { name: 'Ausgeschaltet', value: 'FU004', active: false },
                        { name: 'Statement', value: 'FU003', active: false },
                        { name: 'Wahrzeichen', value: 'FU001', active: false },
                    ]
                },
                {
                    title: 'Anordnung der Sprachen',
                    type: 'arrangement',
                    facets: [
                        { name: 'Duplikat', value: 'AR001', active: false },
                        { name: 'Ergänzung', value: 'AR004', active: false },
                        { name: 'Fragment', value: 'AR002', active: false },
                        { name: 'Überlappung', value: 'AR003', active: false },
                    ]
                },
                {
                    title: 'Visuelle Dominanz',
                    type: 'dominance',
                    facets: [
                        { name: 'Farbe', value: 'DO003', active: false },
                        { name: 'Position', value: 'DO001', active: false },
                        { name: 'Quantiät', value: 'DO005', active: false },
                        { name: 'Schriftgröße', value: 'DO002', active: false },
                        { name: 'Sonstiges', value: 'DO004', active: false },
                    ]
                },
            ]
        };
    }
};
</script>

<style scoped>
.criteria-facets {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
